import React, { Component } from "react";
import Slider from "react-rangeslider";
import PropTypes from "prop-types";
import { scaleLinear } from "d3-scale";
import Axis from "./Axis";

class RangeSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rangeValue: 2016,
    };
  }

  handleChange = (value) => {
    this.setState({
      rangeValue: value,
    });
  };

  handleChangeComplete = () => {
    /** For perfromance, we only update the state of the parent with the rangeValue after
     * the user has finished sliding. This minimizes unecessary re-renders during slider
     * transitions.
     */
    const { rangeValue } = this.state;
    const { updateYear } = this.props;
    updateYear(rangeValue);
  };

  render() {
    const { minRange, maxRange } = this.props;
    const { rangeValue } = this.state;
    const scale = scaleLinear().domain([minRange, maxRange]);
    // .range([0, 100000]);
    return (
      <div className="range-slider__container">
        <Axis
          marginLeft={15}
          marginRight={15}
          type="Top"
          scale={scale}
          customTickValues={["2006", "2008", "2010", "2012", "2014", "2016"]}
        />
        <Slider
          min={minRange}
          max={maxRange}
          value={rangeValue}
          onChange={this.handleChange}
          onChangeComplete={this.handleChangeComplete}
        />
      </div>
    );
  }
}

RangeSlider.propTypes = {
  minRange: PropTypes.number.isRequired,
  maxRange: PropTypes.number.isRequired,
  updateYear: PropTypes.func.isRequired,
};

export default RangeSlider;
